/** @jsx h */
import { h } from 'preact'

const DownloadIcon = ({
  style = {},
  fill = '#054060',
  stroke = '#054060',
  width = '22.385',
  className = '',
  viewBox = '0 0 22.385 18.967'
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`rcc_c_download-icon ${className}`}
    aria-hidden='true'
  >
    <g transform='translate(-213.735 -526.314)' fill='none' strokeMiterlimit='10'>
      <path
        d='M230.413,535.313a8.567,8.567,0,0,1-.062.994h3.384l-5.992,7.135-5.992-7.135h3.564a5.69,5.69,0,0,0,.078-.872,6.814,6.814,0,0,0-11.658-4.795,8.992,8.992,0,0,1,16.678,4.673Z'
        stroke='none'
      />
      <path
        d='M 227.7429962158203 541.8870849609375 L 231.5893402099609 537.3070068359375 L 230.3509979248047 537.3070068359375 L 229.2276306152344 537.3070068359375 L 229.3577270507812 536.1912231445312 C 229.3949127197266 535.8722534179688 229.4129943847656 535.5850219726562 229.4129943847656 535.31298828125 C 229.4129943847656 530.90234375 225.8251037597656 527.3140258789062 221.4149932861328 527.3140258789062 C 220.6477203369141 527.3140258789062 219.8871765136719 527.4246826171875 219.1581726074219 527.6394653320312 C 223.1977691650391 527.9381103515625 226.3930053710938 531.3204345703125 226.3930053710938 535.4349975585938 C 226.3930053710938 535.8279418945312 226.3450622558594 536.1889038085938 226.3032989501953 536.4595336914062 L 226.1725158691406 537.3070068359375 L 225.3150024414062 537.3070068359375 L 223.8966674804688 537.3070068359375 L 227.7429962158203 541.8870849609375 M 227.7429962158203 543.4420166015625 L 221.7510070800781 536.3070068359375 L 225.3150024414062 536.3070068359375 C 225.3589935302734 536.02197265625 225.3930053710938 535.7329711914062 225.3930053710938 535.4349975585938 C 225.3930053710938 531.6699829101562 222.3410034179688 528.6179809570312 218.5760040283203 528.6179809570312 C 216.6820068359375 528.6179809570312 214.9709930419922 529.3920288085938 213.7350006103516 530.6400146484375 C 215.3150024414062 528.0490112304688 218.1589965820312 526.3140258789062 221.4149932861328 526.3140258789062 C 226.3840026855469 526.3140258789062 230.4129943847656 530.343017578125 230.4129943847656 535.31298828125 C 230.4129943847656 535.6500244140625 230.3890075683594 535.9810180664062 230.3509979248047 536.3070068359375 L 233.7350006103516 536.3070068359375 L 227.7429962158203 543.4420166015625 Z'
        stroke='none'
        fill={fill}
      />
    </g>
    <line
      x2='18'
      transform='translate(4.385 18.467)'
      fill='none'
      stroke={stroke}
      strokeMiterlimit='10'
      strokeWidth='1'
    />
  </svg>
)

export default DownloadIcon
